module.exports = __webpack_public_path__ + "static/Dan_Leslie program_English-a0ecab75e0652a9592751fe239fce890.pdf";